import { useCallback } from "react";

export const useServerFilter = (
  { projectStore, uiStore, setAvailBriefs, setPagination, setYearSelected, searchTerm , i, type}
) => {
  const serverFilterProject = useCallback(
    async (years, searchStr, lastId, navId, i, type) => {
      let selectedYear = years;
      const strSch = searchStr ?? searchTerm;
      const SearchString = strSch?.toLowerCase() ?? "";
      const [year1, year2] = selectedYear?.split("/") ?? "";

      let filteredProjects = [];
      let searchbar = document.getElementById("searchbar");
      if (searchbar) {
        searchbar.disabled = true;
        searchbar.focus();
      }
      uiStore.setLoading(true);

      try {
        filteredProjects = await projectStore.getProjectsByFilters(SearchString, year1,year2, lastId,navId, i , type);

        if (Object.keys(filteredProjects).includes("projects") && Array.isArray(filteredProjects.projects)) {
          setAvailBriefs(filteredProjects.projects);
          setPagination({
            currentPage: filteredProjects?.currentPage ?? 1,
            hasMore: filteredProjects?.hasMore ?? false,
            nextCursor: filteredProjects?.nextCursor ?? "",
            prevCursor: filteredProjects?.prevCursor ?? "",
            pageSize: filteredProjects?.pageSize ?? 8,
            totalPages: filteredProjects?.totalPages ?? 0,
            totalItems: filteredProjects?.totalBriefs ?? 0
          });
        } else {
          setAvailBriefs([]);
        }
      } catch (error) {
        setAvailBriefs([]);
      } finally {
        if (searchbar) {
          searchbar.disabled = false;
          searchbar.focus();
        }
        if(i === "" || i === undefined || i === null){
          if(year1 && year2){
            setYearSelected(selectedYear);
          }
        }
        uiStore.setLoading(false);
      }
    },
    [searchTerm, projectStore, uiStore, setAvailBriefs, setPagination, setYearSelected, i, type]
  );
  return { serverFilterProject };
};
